module.exports = __webpack_public_path__ + "img/zanwu.3ce2b73b.png";